import React from 'react';
import { Segment, Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { BarChart, Bar, XAxis, YAxis, Tooltip, LabelList } from 'recharts';
import { center } from '../../Statistics/util';

export default class Chart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {
        return (
            <Segment >
                <Header as="h3">{<FormattedMessage id="professorStatistics.graphicShow" />}</Header>
                <p style={center}>{<FormattedMessage id="professorStatistics.studentsChart" />}</p>
                <BarChart
                    margin={{ top: 60, bottom: 80 }}
                    style={center}
                    width={1000}
                    height={400}
                    data={this.props.data}
                    syncId="anyId"
                >
                    <defs>
                        <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#7ec8db" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#7ec8db" stopOpacity={0} />
                        </linearGradient>
                        <linearGradient id="colorPv" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#003b61" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#003b61" stopOpacity={0} />
                        </linearGradient>
                    </defs>
                    <XAxis hide dataKey="courseImplementationName" />
                    <YAxis />
                    <Tooltip />
                    <Bar type="monotone" dataKey="Broj studenata" stroke="#003b61" fillOpacity={1} fill="url(#colorPv)" >
                        <LabelList dataKey="courseImplementationName" position="bottom" />
                        <LabelList dataKey="Broj studenata" position="top" />
                    </Bar>
                </BarChart>
                <br />
                <br />
                <p style={center}>{<FormattedMessage id="professorStatistics.gradeChart" />}</p>
                <BarChart
                    margin={{ top: 60, bottom: 80 }}

                    style={center}
                    width={1000}
                    height={300}
                    data={this.props.data}
                    syncId="anyId"
                >
                    <XAxis hide dataKey="courseImplementationName" />
                    <YAxis height={10} />
                    <Tooltip />
                    <Bar type="monotone" dataKey="Prosječna ocjena" stroke="#7ec8db" fillOpacity={1} fill="url(#colorUv)" >
                        <LabelList dataKey="courseImplementationName" position="bottom" />
                        <LabelList dataKey="Prosječna ocjena" position="top" />
                    </Bar>
                </BarChart>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/StatisticsForProfessor/Chart.js